module.exports = __webpack_public_path__ + "img/lookbook_5_left.758ebc02.png";